export default class HeroCloud extends Phaser.GameObjects.Image {
    constructor(config) {
        super(config.scene, config.x, config.y, config.key, config.maxX, config.speed);
        this.configX = config.x;
        this.maxX = config.maxX;
        this.speed = config.speed;
        this.scene = config.scene;
        this.scene.add.existing(this);
        this.setOrigin(0, 1);
        this.setScrollFactor(0); 
        this.setDepth(0);
    }

    update() {
    }
}